import { IConfigurationState, IConfigurationStateFulfilled, ISalesForceData, IStateRejected } from '../../interfaces';
import { configurationAction } from '../actions';

const getConfiguration = () => {
  const { pending, fulfilled, rejected } = configurationAction.getConfiguration;
  return {
    // Pending
    [pending.type]: (state: IConfigurationState): IConfigurationState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (_: IConfigurationState, action: IConfigurationStateFulfilled): IConfigurationState => ({
      status: 'success',
      whatsappLink: action.payload.whatsappLink,
      merchantList: action.payload.merchantList,
      paymentMethods: action.payload.paymentMethods,
      typesOperatingSystem: action.payload.typesOperatingSystem,
      cookieNameAuth: action.payload.cookieNameAuth,
      salesForceData: action.payload.salesForceData,
      error: '',
    }),
    // Rejected
    [rejected.type]: (_: IConfigurationState, action: IStateRejected): IConfigurationState => ({
      whatsappLink: '',
      cookieNameAuth: null,
      merchantList: [],
      paymentMethods: [],
      typesOperatingSystem: [],
      status: 'error',
      salesForceData: {} as ISalesForceData,
      error: action.error.message,
    }),
  };
};

export default {
  ...getConfiguration(),
};
